export const aboutPageData = {
    hero: {
        badge: "",
        title: "",
        description:
            "No conventional roadmap led us here. What did was a straightforward approach: be reliable, fair, and accountable, no matter the cost. Purple Octopus Ventures is more about the people than the business, and whether we are distributing equipment, engaging institutions, training teams, or running operations, that consistency is what fuels our credibility.",
        bannerImage: {
            src: "/images/about/banner.jpg",
            alt: "Underwater coral and diving exploration",
        },
    },
    mission: {
        title: 'About Us',
        subtitle: 'Purple Octopus Ventures was established in November 2015 with a simple intention - to make quality equipment available with credibility & reliability, and to set new benchmarks for the dive industry in India.',
        bannerImage: {
            src: 'images/about/mission.jpg',
            alt: 'Mission',
            height: 2000,
            width: 2000
        }
    },
    leaders: {
        title: "The Leadership",
        subtitle:
            "",
        members: [
            {
                name: "Otis D'Souza",
                designation: "Chairman",
                email: "otis@thepurpleoctopus.in",
                image: "/images/about/Otis DSouza.png",
            },
            {
                name: "Siddharth Saini",
                designation: "Founder",
                email: "siddharth@thepurpleoctopus.in",
                image: "/images/about/Siddharth Saini.jpeg",
            },
            {
                name: "Jugal Savla",
                designation: "Founder",
                email: "jugal@thepurpleoctopus.in",
                image: "/images/about/Jugal Savla.jpeg",
            },
        ],
    },
};